import { useRouter, RouteLocationRaw } from "vue-router";

/**
 * カスタム router を取得する
 */
export const useCustomRouter = () => {
  const { push, replace } = useRouter();

  const pushIgnoreError = async (location: RouteLocationRaw) => {
    try {
      await push(location);
    } catch (error) {
      // navigation guard 関係のエラーが頻繁に通知されるので握り潰す
    }
  };

  const replaceIgnoreError = async (location: RouteLocationRaw) => {
    try {
      await replace(location);
    } catch (error) {
      // navigation guard 関係のエラーが頻繁に通知されるので握り潰す
    }
  };

  return {
    pushIgnoreError,
    replaceIgnoreError
  };
};
